var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrorVideoRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 297,
    height: 171.066,
    viewBox: "0 0 297 171.066",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M2.5 167V4L89.5 45V123L2.5 167Z",
    fill: "#AA3631",
    stroke: "#D6AF66",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M294.5 167V4L207.5 45V123L294.5 167Z",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M0 2.5H297",
    stroke: "#D6AF66",
    strokeOpacity: 0.4,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 3",
    d: "M0.491583 168.5L295 168.5",
    stroke: "#D6AF66",
    strokeOpacity: 0.4,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    x1: 90.5,
    y1: 122.5,
    x2: 207.5,
    y2: 122.5,
    stroke: "#D6AF66",
    strokeOpacity: 0.4,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 90.5,
    y1: 45.5,
    x2: 205.5,
    y2: 45.4998,
    stroke: "#D6AF66",
    strokeOpacity: 0.4,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M141.688 134L146.614 116.721M146.614 116.721L151.781 133.504M146.614 116.721V106M138.5 116.721L146.614 106L155.5 116.721",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M144.5 94.5004C144.5 95.1634 144.763 95.7993 145.232 96.2681C145.701 96.737 146.337 97.0004 147 97.0004C147.663 97.0004 148.299 96.737 148.768 96.2681C149.237 95.7993 149.5 95.1634 149.5 94.5004C149.5 93.8373 149.237 93.2015 148.768 92.7326C148.299 92.2638 147.663 92.0004 147 92.0004C146.337 92.0004 145.701 92.2638 145.232 92.7326C144.763 93.2015 144.5 93.8373 144.5 94.5004Z",
    fill: "black",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_0_45",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 133,
    width: 22,
    height: 33,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 133,
    width: 22,
    height: 33,
    rx: 1,
    fill: "#960018",
    stroke: "#D6AF66",
    strokeWidth: 4,
    mask: "url(#path-9-inside-1_0_45)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    x: 14.5,
    y: 138,
    width: 12,
    height: 8,
    rx: 1,
    fill: "#960018",
    stroke: "#D6AF66",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorVideoRight);
export default __webpack_public_path__ + "static/media/mirror-video-right.8edf510928f99ca2467e0a19a6560c34.svg";
export { ForwardRef as ReactComponent };